
















import Vue, { PropType } from "vue";
import { Component } from "vue-property-decorator";
import { RecommendationExtra } from "../store/model";

const DescriptionCellProps = Vue.extend({
  props: {
    rowRecommendation: {
      type: Object as PropType<RecommendationExtra>,
      required: true
    }
  }
});

@Component
export default class DescriptionCell extends DescriptionCellProps {
  get description() {
    return this.rowRecommendation.description;
  }
}
